import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { LucideAngularModule } from "lucide-angular";
import { OrganizationDetailsComponent } from "./organization-details.component";

@NgModule({
  declarations: [OrganizationDetailsComponent],
  imports: [CommonModule, TranslateModule, LucideAngularModule],
  exports: [OrganizationDetailsComponent],
})
export class OrganizationDetailsModule {}
